import {slideToggle, slideUp, index} from '../utility/utils';
import { smoother } from '../utility/gsap';

class BioCard {
  constructor(el) {
    this.el = el;
    this.toggleButton = this.el.querySelector('.bio_card__bio_trigger');
    this.bio = this.el.querySelector('.bio_card__bio');
    if( !this.bio ) return;

    this.resizeDebouncer = null;
    this.breakpoint = 615; // px
    
    this.watchMobileAccordionClicks();

    this.watchResizeForStateChange();
  }

  watchMobileAccordionClicks() {
    this.toggleButton.addEventListener('click', () => {
      this.bio.classList.toggle('active');
      slideToggle(this.bio);

      if(this.bio.classList.contains('active')) {
        this.toggleButton.innerHTML = 'Close';
      } else {
        this.toggleButton.innerHTML = 'Read Bio';
      }

      // If using GSAP ScrollSmoother, prevent it from causing 
      // stuttering while accordion triggers resize events
      if(smoother){
        document.body.classList.add('prevent-smoother-update');
        
        if(window.accordion.smootherUpdateTimeout){
          clearTimeout(window.accordion.smootherUpdateTimeout);
        }

        window.accordion.smootherUpdateTimeout = setTimeout(() => {
          document.body.classList.remove('prevent-smoother-update');
          window.accordion.smootherUpdateTimeout = null;
        }, 500);
      }
    });
  }

  watchResizeForStateChange() {
    window.addEventListener('resize', () => {
      if (this.resizeDebouncer) {
        clearTimeout(this.resizeDebouncer);
      }
      this.resizeDebouncer = setTimeout(() => {
        this.handleResize();
      }, 150);
    });
  }

  handleResize() {
    const windowWidth = window.innerWidth;
    if(windowWidth >= this.breakpoint) {
      // Ensure bio is visible and reset styles
      if(this.bio.classList.contains('active')) {
        this.bio.classList.remove('active');
        this.toggleButton.innerHTML = 'Read Bio';
      }
      this.bio.style.display = '';
      this.bio.style.height = '';
    }
  }
}

export const InitBioCard = () => {
  const els = document.querySelectorAll('.bio_card');
  els.forEach(el => {
    new BioCard(el);
  });
}